module.exports = __webpack_public_path__ + "/login_ui/img/af-77f5da1e522830357e5556d3f570de1f.svg";